<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/histories_sub.jpg" />
      <h1 class="">購入履歴</h1>
    </div>
    <!-- jPages navigation panel -->
    <div class="jPageholder my-5">
      <a v-on:click="prev" class="jp-previous jp-disabled">前頁</a>
      <a v-for="n of maxPage" v-on:click="setPage(n)" :key="n" :class="[currentPage == n?'jp-current':'']">{{n}}</a>
      <a v-on:click="next" class="jp-next">次頁</a>
    </div>
    <Order
      v-for="order in displayOrders"
      :key="order.orderNo"
      :order="order"
    ></Order>
    <!-- jPages navigation panel -->
    <div class="jPageholder my-5">
      <a v-on:click="prev" class="jp-previous jp-disabled">前頁</a>
      <a v-for="n of maxPage" v-on:click="setPage(n)" :key="n" :class="[currentPage == n?'jp-current':'']">{{n}}</a>
      <a v-on:click="next" class="jp-next">次頁</a>
    </div>
  </section>
</template>

<script>
import Order from "./components/Order";
import Request from "@/modules/Request";
let request = new Request();

export default {
  components: {
    Order,
  },
  data() {
    return {
      orders: [],
      displayOrders: [],
      currentPage: 1,
      maxPage: 0,
      pageLines: 10,
    };
  },
  mounted() {
    this.getData();
    window.scroll(0, 0)
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlOrderHistory",
        "getOrderHistory",
        []
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.orders = data;
          this.maxPage = Math.ceil(this.orders.length / this.pageLines);
          this.setPage(1);
        });
    },
    setPage(page) {
      this.currentPage = page;
      let endCount = this.currentPage * this.pageLines;
      let startCount = endCount - this.pageLines;
      this.displayOrders = this.orders.slice(startCount,endCount);
    },
    next() {
      if (this.currentPage == this.maxPage) return;
      this.setPage(this.currentPage+1)
    },
    prev() {
      if (this.currentPage == 1) return;
      this.setPage(this.currentPage-1)
    },
  },
};
</script>